export default __webpack_public_path__ + "static/media/Billing.c36ec0dc.svg";